import PropTypes from 'prop-types';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const ModalVerReserva = ({ modalState }) => {
    const { reserva } = modalState.data;

    return (
        <Modal
            isOpen={modalState.show}
            size={"lg"}
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <ModalHeader className="bg-secondary text-white text-bold">
                Ver reserva
            </ModalHeader>
            <ModalBody>
                <div className="form-label-group">
                    <h4
                        className="font-weight-bold text-center p-1"
                        htmlFor="reserva"
                    >
                        Datos Reserva <i className="fa fa-calendar-plus"></i>
                    </h4>
                    <div className="row text-center" id="datosReservaInfo">
                        <div className="col-6 text-left">
                            <i className="fas fa-hospital mr-1"></i>
                            {reserva?.lugar?.sede?.sigla}
                        </div>
                        <div className="col-6 text-left">
                            <i className="fas fa-map-marked-alt mr-1"></i>
                            {reserva?.lugar?.nombre}
                        </div>
                        <div className="col-6 text-left">
                            <i className="fas fa-box mr-1"></i>
                            {reserva?.recurso?.nombre}
                        </div>
                        <div className="col-6 text-left">
                            <i className="fas fa-comment mr-1"></i>
                            {reserva?.asunto}
                        </div>
                        <div className="col-6 text-left">
                            <i className="fas fa-chalkboard-teacher mr-1"></i>
                            {reserva?.tema?.nombre}
                        </div>
                        <div className="col-6 text-left">
                            <i className="fas fa-calendar-check mr-1"></i>
                            {reserva?.fecha}
                        </div>
                        <div className="col-6 text-left">
                            <i className="fas fa-clock mr-1"></i>
                            Desde las {reserva?.hora_inicio} hasta las {reserva?.hora_fin}
                        </div>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    onClick={() => modalState.close()}
                    className="btn-secondary"
                >Cerrar</Button>
            </ModalFooter>
        </Modal>
    );
};

ModalVerReserva.propTypes = {
    modalState: PropTypes.object
}

export default ModalVerReserva;
